// extracted by mini-css-extract-plugin
export default {"button":"HAYSQ","title":"mv5Tr","subtitle":"yKsKB","section":"lPqrc","container":"Sfp8G","image":"WWK_e","tagContainer":"P7I2Y"};